"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ANNUAL = exports.MONTHLY = void 0;
var MONTHLY = 'monthly';
exports.MONTHLY = MONTHLY;
var ANNUAL = 'annual';
exports.ANNUAL = ANNUAL;